import { compact, getSlotCompoundVariant, memo, splitProps } from '../helpers.mjs';
import { createRecipe } from './create-recipe.mjs';

const ghostTextFieldDefaultVariants = {
  "size": "md"
}
const ghostTextFieldCompoundVariants = []

const ghostTextFieldSlotNames = [
  [
    "root",
    "ghostTextField__root"
  ],
  [
    "textarea",
    "ghostTextField__textarea"
  ],
  [
    "endAdornment",
    "ghostTextField__endAdornment"
  ]
]
const ghostTextFieldSlotFns = /* @__PURE__ */ ghostTextFieldSlotNames.map(([slotName, slotKey]) => [slotName, createRecipe(slotKey, ghostTextFieldDefaultVariants, getSlotCompoundVariant(ghostTextFieldCompoundVariants, slotName))])

const ghostTextFieldFn = memo((props = {}) => {
  return Object.fromEntries(ghostTextFieldSlotFns.map(([slotName, slotFn]) => [slotName, slotFn.recipeFn(props)]))
})

const ghostTextFieldVariantKeys = [
  "size"
]
const getVariantProps = (variants) => ({ ...ghostTextFieldDefaultVariants, ...compact(variants) })

export const ghostTextField = /* @__PURE__ */ Object.assign(ghostTextFieldFn, {
  __recipe__: false,
  __name__: 'ghostTextField',
  raw: (props) => props,
  classNameMap: {},
  variantKeys: ghostTextFieldVariantKeys,
  variantMap: {
  "size": [
    "md",
    "sm"
  ]
},
  splitVariantProps(props) {
    return splitProps(props, ghostTextFieldVariantKeys)
  },
  getVariantProps
})